import { z } from "zod";
import {
  DTODocumentationGroupCreateActionInputV2,
  DTODocumentationGroupCreateActionOutputV2,
  DTODocumentationGroupDeleteActionInputV2,
  DTODocumentationGroupDeleteActionOutputV2,
  DTODocumentationGroupDuplicateActionInputV2,
  DTODocumentationGroupDuplicateActionOutputV2,
  DTODocumentationGroupMoveActionInputV2,
  DTODocumentationGroupMoveActionOutputV2,
  DTODocumentationGroupUpdateActionInputV2,
  DTODocumentationGroupUpdateActionOutputV2,
  DTODocumentationTabCreateActionInputV2,
  DTODocumentationTabCreateActionOutputV2,
  DTODocumentationTabGroupDeleteActionInputV2,
  DTODocumentationTabGroupDeleteActionOutputV2,
} from "./documentation/group-action";
import {
  DTODocumentationGroupRestoreActionInput,
  DTODocumentationGroupRestoreActionOutput,
  DTODocumentationPageApprovalStateChangeActionInput,
  DTODocumentationPageApprovalStateChangeActionOutput,
  DTODocumentationPageCreateActionInputV2,
  DTODocumentationPageCreateActionOutputV2,
  DTODocumentationPageDeleteActionInputV2,
  DTODocumentationPageDeleteActionOutputV2,
  DTODocumentationPageDuplicateActionInputV2,
  DTODocumentationPageDuplicateActionOutputV2,
  DTODocumentationPageMoveActionInputV2,
  DTODocumentationPageMoveActionOutputV2,
  DTODocumentationPageRestoreActionInput,
  DTODocumentationPageRestoreActionOutput,
  DTODocumentationPageUpdateActionInputV2,
  DTODocumentationPageUpdateActionOutputV2,
  DTODocumentationPageUpdateDocumentActionInputV2,
  DTODocumentationPageUpdateDocumentActionOutputV2,
} from "./documentation/page-actions-v2";
import {
  DTOFigmaNodeRenderActionInput,
  DTOFigmaNodeRenderActionOutput,
  DTOFigmaNodeRenderAsyncActionInput,
  DTOFigmaNodeRenderAsyncActionOutput,
} from "./figma-nodes/node-actions-v2";
import { DTOElementPropertyValuesEditActionInput, DTOElementPropertyValuesEditActionOutput } from "./properties";

//
// Read
//

export const DTOElementActionOutput = z.discriminatedUnion("type", [
  // Documentation pages
  DTODocumentationPageCreateActionOutputV2,
  DTODocumentationPageUpdateActionOutputV2,
  DTODocumentationPageUpdateDocumentActionOutputV2,
  DTODocumentationPageMoveActionOutputV2,
  DTODocumentationPageDuplicateActionOutputV2,
  DTODocumentationPageDeleteActionOutputV2,

  // Documentation groups
  DTODocumentationGroupCreateActionOutputV2,
  DTODocumentationTabCreateActionOutputV2,
  DTODocumentationGroupUpdateActionOutputV2,
  DTODocumentationGroupMoveActionOutputV2,
  DTODocumentationGroupDuplicateActionOutputV2,
  DTODocumentationGroupDeleteActionOutputV2,
  DTODocumentationTabGroupDeleteActionOutputV2,

  // Figma frames
  DTOFigmaNodeRenderActionOutput,
  DTOFigmaNodeRenderAsyncActionOutput,

  // Restore
  DTODocumentationPageRestoreActionOutput,
  DTODocumentationGroupRestoreActionOutput,

  // Approvals
  DTODocumentationPageApprovalStateChangeActionOutput,

  // Element properties
  DTOElementPropertyValuesEditActionOutput,
]);

export type DTOElementActionOutput = z.infer<typeof DTOElementActionOutput>;

//
// Write
//

export const DTOElementActionInput = z
  .discriminatedUnion("type", [
    // Documentation pages
    DTODocumentationPageCreateActionInputV2,
    DTODocumentationPageUpdateActionInputV2,
    DTODocumentationPageUpdateDocumentActionInputV2,
    DTODocumentationPageMoveActionInputV2,
    DTODocumentationPageDuplicateActionInputV2,
    DTODocumentationPageDeleteActionInputV2,

    // Documentation groups
    DTODocumentationGroupCreateActionInputV2,
    DTODocumentationTabCreateActionInputV2,
    DTODocumentationGroupUpdateActionInputV2,
    DTODocumentationGroupMoveActionInputV2,
    DTODocumentationGroupDuplicateActionInputV2,
    DTODocumentationGroupDeleteActionInputV2,
    DTODocumentationTabGroupDeleteActionInputV2,

    // Figma frames
    DTOFigmaNodeRenderActionInput,
    DTOFigmaNodeRenderAsyncActionInput,

    // Restore
    DTODocumentationPageRestoreActionInput,
    DTODocumentationGroupRestoreActionInput,

    // Approval
    DTODocumentationPageApprovalStateChangeActionInput,

    // Element properties
    DTOElementPropertyValuesEditActionInput,
  ])
  .and(
    z.object({
      tId: z.string().optional(),
    })
  );

export type DTOElementActionInput = z.infer<typeof DTOElementActionInput>;
export type DTOElementActionInputOfType<T extends DTOElementActionInput["type"]> = Extract<
  DTOElementActionInput,
  { type: T }
>;
